import React, { useContext } from "react";
import useViewSize from "../../hooks/use-view-size";

import { SurveySplashDataContext } from "../../providers/survey-splash-data";

import SurveySplashCarouselCard from "./card";
import SurveySplashCarouselWelcome from "./welcome";

const SurveySplashCarousel = ({ onClickStart }) => {
  const { width } = useViewSize();
  const { surveyMetadata, welcomeData } = useContext(SurveySplashDataContext);
  const { surveyRoute } = surveyMetadata;
  const carouselId = `carousel-${surveyRoute}`;
  const showParticipantsFooter = surveyRoute === "ence-2026";

  return (
    <div
      id={carouselId}
      className={`carousel slide ${width <= 768 ? "animated--fade-in" : "animated--grow-in"}`}
      data-interval="false"
      data-ride="carousel"
    >
      <div className="carousel-inner" role="listbox">
        <SurveySplashCarouselCard
          id={carouselId}
          orientation="left"
          lastCard
          active
          showParticipantsFooter={showParticipantsFooter}
          onClickStart={onClickStart}
        >
          <SurveySplashCarouselWelcome survey={surveyMetadata} welcome={welcomeData} />
        </SurveySplashCarouselCard>
      </div>
    </div>
  );
};

export default SurveySplashCarousel;